import { logtoClient } from "../../service/Logto";
import Header from "../../components/Header";
import Button from "../../components/Button";
import useToggle from "../../hooks/useToggle";
import useAuthentication from "../../hooks/checkAuthentication";
import { useRef } from "react";
import { Navigate } from "react-router";

function Auth() {
  const {
    value: isLoading,
    setTrue: startLoader,
    setFalse: stopLoader,
  } = useToggle(false);
  const userTryTracker = useRef(1);

  const { isAuthenticated, isLoading: authloader } = useAuthentication();

  const handleSignIn = async () => {
    startLoader();
    try {
      if (isAuthenticated && userTryTracker.current > 2) {
        await logtoClient.signOut(`${window.location.origin}/`);
      }
      userTryTracker.current += 1;
      await logtoClient.signIn({
        redirectUri: `${window.location.origin}/callback`,
        firstScreen: "signIn",
      });
    } catch (error) {
      stopLoader();
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/contracts" replace />;
  }

  return (
    <div>
      <Header isAuthenticated={isAuthenticated || false} />
      {!isAuthenticated && (
        <div className="container">
          <div className="flex justify-center items-center flex-auto py-5 min-h-[calc(100dvh-74px)]">
            <div className="bg-white border border-gray-200 rounded-3xl px-6 grid gap-y-12 py-12 max-w-[500px] w-full">
              <h1 className="text-xl text-center font-semibold">
                Welcome to the Dealer Portal! Please click on the button below
                to access the system.
              </h1>
              <div className="flex justify-center">
                <Button
                  variant="blue"
                  isLoading={isLoading || authloader}
                  disabled={isLoading || authloader}
                  onClick={handleSignIn}
                  btnClassName="w-full"
                >
                  Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Auth;
